<template>
	<div class="">
		<div class="banners">
			<div class="main-container">
				<div class="main-header-z">
					<div class="header-content">
						<ProductToolbar />
					</div>
				</div>


				<div class="sidebar">
					<Sidebar ref="sidebarRef" @subsidebar-toggled="handleSubSidebarToggle" />
				</div>

				<div class="content">
					<div class="row">
						<div class="col">
							<router-view />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Sidebar from '../components/Sidebar.vue';
import ProductToolbar from '../components/ProductToolbar.vue';

export default {

	components: {
		Sidebar,
		ProductToolbar,
	},

	data() {
		return {
			isSubSidebarOpen: false,
		}
	},

	computed: {
		contentStyle() {
			return {
				'margin-left': this.isSubSidebarOpen ? '255px' : '0px',
				'transition': 'margin-left 0.25s ease'
			}
		}
	},

	created() {
		if (this.$store.state.auth.isAuthenticated == false) {
					this.$store.dispatch('auth/logout');
			}
	},

	mounted() {
		this.init();
	},

	methods: {
		handleSubSidebarToggle(isOpen) {
			this.isSubSidebarOpen = isOpen;
		},

		init() {
			
		},
	}

}
</script>

<style>
#content {
	position: relative;
	z-index: 999;
}

.main-header-z {
	position: absolute;
	height: 66px;
	z-index: 900 !important;
	top: 0;
	width: 100%;
	background-color: #00a0c1;
}

.header-content {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: 100%;
	padding: 0 20px;
	gap: 12px;
}



.to-front {
	z-index: 0 !important;
	position: relative;
}

.to-back {
	z-index: 0;
	position: relative;
}

#content img {
	position: absolute;
	top: 0px;
	right: 25px;
	width: 65px;
	height: 65px;
}
</style>
